import React from "react";
import { Separator } from "@/components/ui/separator";
import {
  Tooltip,
  TooltipContent,
  TooltipTrigger,
} from "@/components/ui/tooltip";
import { Info } from "lucide-react";
import ExpandableSection from "./ExpandableSection";
import BrandGroup from "./BrandGroup";

interface BrandGroup {
  brandName: string;
  products: any[];
  subtotal: number;
}

interface ScheduledItemsSectionProps {
  hasScheduledItems: boolean;
  isExpanded: boolean;
  onToggle: () => void;
  brandGroups: BrandGroup[];
  totalQuantity: number;
  totalValue: number;
  studentQuantity: number;
  teacherQuantity: number;
  formatCurrency: (value: number) => string;
  title?: string;
  tooltipText?: string;
  /** Itens de 2º semestre cobertos pelo cupom, mostrados ao final do bloco. */
  couponContent?: React.ReactNode;
}

const ScheduledItemsSection = ({
  hasScheduledItems,
  isExpanded,
  onToggle,
  brandGroups,
  totalQuantity,
  totalValue,
  studentQuantity,
  teacherQuantity,
  formatCurrency,
  title = "Pedido programado 2º semestre",
  tooltipText = "As quantidades poderão ser ajustadas até 01/06/2026",
  couponContent,
}: ScheduledItemsSectionProps) => {
  if (!hasScheduledItems) return null;

  const itemCount =
    brandGroups?.reduce((acc, brand) => acc + brand.products.length, 0) || 0;

  return (
    <>
      <Separator />
      <ExpandableSection
        title={`${title} - ${tooltipText}`}
        icon="📋"
        isExpanded={isExpanded}
        onToggle={onToggle}
        itemCount={itemCount}
        totalValue={totalValue}
        formatCurrency={formatCurrency}
        colorScheme="scheduled"
      >
        {brandGroups?.map((brandGroup, brandIndex) => (
          <BrandGroup
            key={`brand-${brandIndex}`}
            brandName={brandGroup.brandName}
            products={brandGroup.products}
            subtotal={brandGroup.subtotal}
            formatCurrency={formatCurrency}
            colorScheme="purple"
            showQuantity
          />
        ))}
        {couponContent}
      </ExpandableSection>
    </>
  );
};

export default ScheduledItemsSection;
